import React from 'react'
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa'

function Footer() {
  return (
    <footer className="bg-gradient-royal text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* About Section */}
          <div className="space-y-4">
            <div className="pb-3 mb-4 border-b-2 border-accent-gold">
              <h3 className="text-2xl font-bold">About Us</h3>
            </div>
            <p className="text-neutral-100 leading-relaxed">
              Ghana Students' Most Beautiful is a TV Reality Program just like you for Miss Ghana, Ghana's Most Beautiful, Miss Malaika etc. It is the highest Beauty Pageantry granted to all Female students across all Institutions in Ghana.
            </p>
            <p className="text-neutral-100 leading-relaxed">
              The Ghana Students' Most Beautiful started in 2021 and the next one will be the 3rd Edition.
            </p>
          </div>

          {/* Contact Section */}
          <div className="space-y-4">
            <div className="pb-3 mb-4 border-b-2 border-accent-gold">
              <h3 className="text-2xl font-bold">Contact Us</h3>
            </div>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <FaMapMarkerAlt className="text-accent-gold text-xl mt-1 flex-shrink-0" />
                <p className="text-neutral-100">Accra, Ghana</p>
              </div>
              <div className="flex items-start gap-3">
                <FaPhone className="text-accent-gold text-xl mt-1 flex-shrink-0" />
                <p className="text-neutral-100">+233204933598 / +233548503799</p>
              </div>
              <div className="flex items-start gap-3">
                <FaEnvelope className="text-accent-gold text-xl mt-1 flex-shrink-0" />
                <p className="text-neutral-100">ghanastudentsmostbeautiful@gmail.com</p>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-white/20 text-center">
          <p className="text-neutral-200 text-sm">
            © {new Date().getFullYear()} Ghana Students' Most Beautiful. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
